export default __webpack_public_path__ + "static/media/rose_hulman.54b17e6e.png";